import i18n from "i18next";
import { initReactI18next, Translation } from "react-i18next";
import { readTranslations } from "../Api";
import { useEffect, useState } from "react";

i18n
    .use(initReactI18next)
    .init({
        partialBundledLanguages: true,
        lng: localStorage.getItem("NG_TRANSLATE_LANG_KEY") ?? '',
        ns: ['translations'],
        interpolation: {
            escapeValue: false
        },
        resources: {},
    })

export default i18n

export function initializeTranslations() {
    const languageKey = localStorage.getItem("NG_TRANSLATE_LANG_KEY")

    readTranslations().then((resource) => {
        i18n.addResourceBundle(languageKey ?? '', 'translations', resource)
    }) 
}





